import gql from "graphql-tag";

export const SiteObjectQuery = gql `
query{
    getSiteObject {
      response
    }
}
`;

export const getSitesQuery = gql `
query($input: SiteGroupFilter!){
  sites(input: $input) {
    sites{
      _id
      sitename
      sitegroupId
      contractstartdate
      postcode
      metadata
      sitegroupDetail
      siteArea
      customerDetail
      branchDetail
      isInternalSite
      siteskills
      trainedEmpDuty
      keyDetail
      sitePayDetail
      pay
      payCurrency
      isArchived
    }
    

    totalCount
    currentPage
    totalPages

  }
}
`;

export const SiteDuplicatesQuery = gql `
query{
  siteDuplicates {
    success
    message
    response
  }
}
`;

// Real-time equivalent of the same check the hourly siteDuplicate cron does -
// used on the create-site form so staff see a warning before submitting.
export const CheckSiteDuplicateQuery = gql `
query($sitename: String!, $postcode: String!){
  checkSiteDuplicate(sitename: $sitename, postcode: $postcode) {
    response
  }
}
`;

export const getSiteQuery = gql `
query($id: String!){
  site(_id: $id) {
    response
  }
}
`;

// Right sidebar's "Keys" card and Termination Pending blocker text - reuses
// getAllKeys (keyRegister.query.js's getAllKeysQuery), scoped to one site.
export const GetSiteKeysSummaryQuery = gql `
query($siteId: String!){
  getAllKeys(input: {siteId: $siteId, page: 1, pageSize: 100}) {
    totalCount
    response {
      _id
      siteId
      keySerial
      status
      expectedReceiptDate
      custodianType
      custodianDetail
      returnToCustomer
      returnRequested
      returnRequestExpectedDate
      returnDate
      site {
        sitename
      }
      keyTypes {
        type
        count
      }
    }
  }
}
`;

// Right sidebar's "Status History" timeline.
export const GetSiteStatusHistoryQuery = gql `
query($siteId: String!){
  getSiteStatusHistory(siteId: $siteId) {
    message
    response {
      _id
      fromStatus
      toStatus
      changedAt
      source
      contractEndDate
      changedByName
    }
  }
}
`;

// Pre-save check for the "Site Status → Terminated" flow - what's still
// live on this site beyond the given contract end date (rota rolling,
// guarding duties, mobile service templates/loaded duties, keys). See
// siteTerminationCheckModal.jsx.
export const GetSiteTerminationImpactQuery = gql `
query($siteId: String!, $contractEndDate: String!){
  getSiteTerminationImpact(siteId: $siteId, contractEndDate: $contractEndDate) {
    message
    response
  }
}
`;

export const getSitesForMapQuery = gql`
  query GetSitesForMap($input: SiteGroupFilter) {
    getSitesForMap(input: $input) {
      sites
      total
    }
  }
`;

export const singleSiteDetailForOperationalTabId = gql `
query($singleSiteDetailForOperationalTabId: String!){
  singleSiteDetailForOperationalTab(id: $singleSiteDetailForOperationalTabId) {
    response
  }
}
`;